import { render, staticRenderFns } from "./DM_flowBackInfo.vue?vue&type=template&id=372df7f9&"
import script from "./DM_flowBackInfo.vue?vue&type=script&lang=js&"
export * from "./DM_flowBackInfo.vue?vue&type=script&lang=js&"
import style0 from "./DM_flowBackInfo.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports